module.exports = Quill;


//////////////////
// WEBPACK FOOTER
// external "Quill"
// module id = Y9Xt
// module chunks = 8